import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/vetsy-app-qr.svg")